import { Component, useRef } from 'react'
import { BarGraph } from './BarGraph.d'
import React, { MouseEvent, useEffect, useState } from 'react'

export interface BarGraphItemProps {
  g: BarGraph
}

const BarGraphItem = ({ g }: BarGraphItemProps) => {
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 1) {
          activateGraph(entry.target)
        }
      },
      {
        threshold: 1.0
      }
    )
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  const activateGraph = (target: any) => {
    const graphItem = querySelfOrChildren(target, '.otl-bar-graph__item')
    let bar = querySelfOrChildren(target, '.otl-bar-graph__bar')

    bar.style.width = `${graphItem.dataset.percentage}%`
    bar.style.transition = `width 0.8s ease-in-out`
  }

  const querySelfOrChildren = (element: any, selector: any) => {
    if (element.matches(selector)) {
      return element
    } else {
      return element.querySelector(selector)
    }
  }

  const handleMouseEvent = (e: MouseEvent<HTMLSpanElement>) => {
    let target = e.currentTarget as HTMLSpanElement
    const bar = querySelfOrChildren(target, '.otl-bar-graph__bar')
    bar.style.width = '0%'
    bar.style.transition = 'none'

    setTimeout(() => {
      const graphItem = querySelfOrChildren(target, '.otl-bar-graph__item')
      const bar = querySelfOrChildren(graphItem, '.otl-bar-graph__bar')

      bar.style.width = `${graphItem.dataset.percentage}%`
      bar.style.transition = `width 0.8s ease-in-out`
    }, 500)
  }

  return (
    <div
      ref={ref}
      className='otl-bar-graph__item'
      data-percentage={`${g.percentage}`}
      onMouseEnter={handleMouseEvent}
    >
      <div className='otl-bar-graph__label'>
        <h3>{g.label}</h3>
        <h3>{g.percentage}%</h3>
      </div>
      <div className='otl-bar-graph__graph'>
        <span className='otl-bar-graph__bar'></span>
      </div>
    </div>
  )
}

export default BarGraphItem
